import script from "./TabelaUsuarios.vue?vue&type=script&setup=true&lang=js"
export * from "./TabelaUsuarios.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__
import QLinearProgress from 'quasar/src/components/linear-progress/QLinearProgress.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QLinearProgress,QTable,QTd,QBtn});
